import { Eyebrow, SectionTitle } from "../Eyebrow";

const ROWS = [
    ["Commission de mouvement", "0,15 % · 15 000 €", "Au-dessus du marché", true],
    ["Commission d'engagement", "0,50 % du non-tiré", "Négociable"],
    ["Tenue de compte", "× 3 banques", "Doublons à rationaliser"],
    ["Monétique / TPE", "Par transaction", "À remettre en concurrence"],
];

const Row = ({ cells, header = false, last = false }) => (
    <div
        className={`grid grid-cols-3 gap-2 ${
            header
                ? "pb-2.5 border-b-2 border-navy text-xs font-semibold uppercase tracking-[0.08em] text-grey-text-soft"
                : `py-3 text-sm text-navy ${last ? "" : "border-b border-border-default"}`
        }`}
    >
        {cells}
    </div>
);

export const StatementExample = () => (
    <section className="bg-cream border-y border-border-default" data-testid="home-statement">
        <div className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-10 md:py-16 lg:py-20 flex flex-wrap gap-x-14 gap-y-6 md:gap-y-10 items-start">
            <div className="flex-1 basis-[320px] min-w-0 flex flex-col gap-3.5">
                <Eyebrow>La lecture d'un ex-banquier</Eyebrow>
                <SectionTitle>Ce que nous voyons dans vos relevés.</SectionTitle>
                <p className="m-0 text-base leading-[1.65] text-grey-text-soft">
                    Une PME française qui réalise 15 M€ paie en moyenne 20 000 € par an pour la seule utilisation de
                    ses comptes. Avec de l'international, jusqu'à 50 000 €.
                </p>
            </div>
            <div className="flex-1 basis-[520px] min-w-0 bg-white border border-border-default rounded-xl p-5 md:p-7 flex flex-col gap-3.5">
                <div className="flex flex-wrap justify-between gap-3 text-[13px] md:text-xs font-semibold uppercase tracking-[0.12em] text-grey-text-soft">
                    <span>10 M€ de flux · 3 banques</span>
                    <span>Exemple illustratif</span>
                </div>
                <div className="md:hidden flex flex-col border-t-2 border-navy" data-testid="statement-mobile-list">
                    {ROWS.map(([line, billed, finding, strong], i) => (
                        <div key={line} className={`flex flex-col gap-1 py-3 ${i < ROWS.length - 1 ? "border-b border-border-default" : ""}`}>
                            <span className="text-[15px] font-semibold text-navy">{line}</span>
                            <div className="flex justify-between gap-3 text-sm"><span className="text-grey-text-soft">Facturé</span><span className="text-right text-navy">{billed}</span></div>
                            <div className="flex justify-between gap-3 text-sm"><span className="text-grey-text-soft">Constat</span><span className={`text-right ${strong ? "font-bold text-gold-text" : "text-navy"}`}>{finding}</span></div>
                        </div>
                    ))}
                </div>
                <div className="hidden md:block">
                    <div className="flex flex-col">
                        <Row header cells={[<span key="a">Ligne</span>, <span key="b">Facturé</span>, <span key="c">Constat</span>]} />
                        {ROWS.map(([line, billed, finding, strong], i) => (
                            <Row
                                key={line}
                                last={i === ROWS.length - 1}
                                cells={[
                                    <span key="a" className="font-semibold">{line}</span>,
                                    <span key="b">{billed}</span>,
                                    strong ? <strong key="c" className="text-gold-text">{finding}</strong> : <span key="c">{finding}</span>,
                                ]}
                            />
                        ))}
                    </div>
                </div>
                <div className="bg-navy text-white px-4 py-3.5 text-sm leading-[1.55] rounded-md">
                    Votre compte <strong className="text-gold">627000</strong> progresse chaque année ? Il y a de
                    l'argent à récupérer.
                </div>
            </div>
        </div>
    </section>
);
